import React from 'react';
import PropTypes from 'prop-types';
import { NeoTabs } from '../../../../components/Common';
import { MEMBER_PROFILE_TABS } from '../constants';

/**
 * ProfileTabs
 * Abas superiores do cabeçalho do Perfil do Aluno.
 * Centralizado para utilizar o componente NeoTabs com variante 'header' (translúcido outonal).
 */
const ProfileTabs = ({ activeTab, toggleTab, tabs = MEMBER_PROFILE_TABS }) => {
    return (
        <NeoTabs
            tabs={tabs}
            activeTab={activeTab}
            onChangeTab={toggleTab}
            variant="header"
        />
    );
};

ProfileTabs.propTypes = {
    activeTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    toggleTab: PropTypes.func.isRequired,
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
            label: PropTypes.string.isRequired,
            icon: PropTypes.string
        })
    )
};

export default ProfileTabs;
